import { Component } from '@angular/core';

@Component({
  selector: 'app-trx-price',
  templateUrl: './trx-price.component.html',
  styleUrls: ['./trx-price.component.scss']
})
export class TrxPriceComponent {

}
